import React from "react";
import NextLink from "next/link";
import { Link as GDKLink } from "@graffer-inc/graffer-design-kit";

type LinkProps = {
  href: string;
  children?: React.ReactNode;
} & Omit<React.ComponentProps<typeof GDKLink>, "anchor">;

// TODO next用Link、移行後削除
export const Link: React.FC<LinkProps> = ({ href, children, ...props }) => {
  return (
    <GDKLink
      {...props}
      anchor={({ children: innerChildren, ...innerProps }) => (
        <NextLink {...innerProps} href={href} prefetch={false}>
          {innerChildren}
        </NextLink>
      )}
    >
      {children}
    </GDKLink>
  );
};
